import * as actionTypes from '../actionTypes';

export const openToaster = (content, variant = "success") => {
  return {
    type: actionTypes.OPEN_TOASTER,
    content,
    variant,
  };
};

export const closeToaster = () => {
  return {
    type: actionTypes.CLOSE_TOASTER,
  };
};
